module.exports = __webpack_public_path__ + "img/4.583b7b9e.jpg";